module.exports = __webpack_public_path__ + "static/media/location rojo.e39d7e6c.svg";